
const digest = '0e904da78ce5e4a1e193a338aeef142977530bfe6142cf0d4a31bccfe156ce21';
const classes = {"wrapper":"_wrapper_9su5y_1","day":"_day_9su5y_6","month":"_month_9su5y_9","year":"_year_9su5y_12"};
const css = `._wrapper_9su5y_1 {
  display: flex;
  flex-direction: row;
  gap: 10px;
}
._wrapper_9su5y_1 ._day_9su5y_6 {
  flex: 1;
}
._wrapper_9su5y_1 ._month_9su5y_9 {
  flex: 1;
}
._wrapper_9su5y_1 ._year_9su5y_12 {
  flex: 1;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  